// Auto-generated client configuration - DO NOT EDIT MANUALLY
// Generated by frontend/scripts/prepare-client.js from clients/{CLIENT_ID}/config.json.
// This file is regenerated at every build and is gitignored.

export const CLIENT_CONFIG = {
  "client_id": "hca",
  "features": {
    "vanilla_chat": true,
    "internet_search": false,
    "gpt_search": false,
    "internal_search": true,
    "agents": false,
    "model_selection": false,
    "document_upload": true,
    "custom_login": false
  },
  "languages": [
    "en",
    "nl",
    "hu",
    "id"
  ],
  "theme": {
    "name": "Holland Colours",
    "colors": {
      "primary": "#DA272B",
      "secondary": "#49A79E",
      "accent": "#EF7D00",
      "background": "#FFFFFF",
      "surface": "#f6f6f6",
      "text": {
        "primary": "#27272b",
        "secondary": "#4A5568",
        "muted": "#A0AEC0"
      },
      "success": "#38A169",
      "warning": "#D69E2E",
      "error": "#E53E3E"
    },
    "branding": {
      "logoUrl": "/assets/hca/logo.png",
      "showLogoInHeader": true,
      "faviconUrl": "/assets/hca/favicon.ico",
      "agentIconUrl": "/assets/hca/agentIcon.png",
      "internalIconUrl": "/assets/hca/internalIcon.png",
      "companyName": "Holland Colours",
      "assistantName": "Holly",
      "tagline": "AI Assistant",
      "supportEmail": "itsupport@hollandcolours.com",
      "backgroundImage": "/assets/hca/background.webp"
    },
    "typography": {
      "fontFamily": "'Open Sans', system-ui, sans-serif",
      "headingFontFamily": "'Open Sans', system-ui, sans-serif"
    },
    "layout": {
      "sidebarWidth": "300px",
      "headerHeight": "72px",
      "borderRadius": "8px",
      "loginCardOffsetY": {
        "base": "8vh",
        "md": "10vh"
      }
    },
    "customTexts": {
      "welcomeMessage": "Welcome to the Holland Colours AI Assistant",
      "chatPlaceholder": "Ask me anything...",
      "footerText": "Holland Colours - AI Assistant",
      "thinkingMessages": {
        "en": [
          "Mixing the right shade...",
          "Searching the palette...",
          "Matching the perfect hue...",
          "Blending the details...",
          "Bringing it to color..."
        ],
        "nl": [
          "De juiste kleur mengen...",
          "Het palet doorzoeken...",
          "De perfecte tint vinden...",
          "De details samenvoegen...",
          "Kleur geven aan het antwoord..."
        ],
        "hu": [
          "A megfelelő árnyalat keverése...",
          "A paletta átböngészése...",
          "A tökéletes színárnyalat keresése...",
          "A részletek összehangolása...",
          "Színt adunk a válasznak..."
        ],
        "id": [
          "Mencampur warna yang tepat...",
          "Menelusuri palet...",
          "Menemukan rona yang sempurna...",
          "Memadukan detailnya...",
          "Memberi warna pada jawaban..."
        ]
      },
      "noAccessMessage": {
        "en": "You currently have no access to any HR SharePoint sites, so Holly can't use those documents to answer your questions. To request access, please create a support ticket or email IT support at itsupport@hollandcolours.com. You can still use Holly for general questions and tasks such as summarizing documents.",
        "nl": "Je hebt op dit moment geen toegang tot HR SharePoint-sites, dus Holly kan die documenten niet gebruiken om je vragen te beantwoorden. Om toegang aan te vragen, maak een supportticket aan of stuur een e-mail naar IT-support via itsupport@hollandcolours.com. Je kunt Holly nog steeds gebruiken voor algemene vragen en taken zoals het samenvatten van documenten.",
        "hu": "Jelenleg nincs hozzáférésed egyetlen HR SharePoint-oldalhoz sem, így a Holly nem tudja ezeket a dokumentumokat felhasználni a kérdéseid megválaszolásához. A hozzáférés igényléséhez hozz létre egy support jegyet, vagy írj az IT-ügyfélszolgálatnak az itsupport@hollandcolours.com címen. A Hollyt továbbra is használhatod általános kérdésekhez és feladatokhoz, például dokumentumok összefoglalásához.",
        "id": "Saat ini Anda tidak memiliki akses ke situs SharePoint HR mana pun, sehingga Holly tidak dapat menggunakan dokumen tersebut untuk menjawab pertanyaan Anda. Untuk meminta akses, silakan buat tiket dukungan atau kirim email ke dukungan IT di itsupport@hollandcolours.com. Anda tetap dapat menggunakan Holly untuk pertanyaan umum dan tugas seperti meringkas dokumen."
      }
    },
    "informationModal": {
      "en": {
        "title": "About the Holly assistant",
        "intro": "Welcome to the Holly assistant. Below you will find what the assistant can help you with and how to get the most out of it. Holly runs in a secure Holland Colours environment, so your data stays within the company.",
        "sections": [
          {
            "heading": "What can the assistant help you with?",
            "items": [
              "The assistant can answer questions like the ones you would ask ChatGPT.",
              "The assistant has broad general knowledge, but does not know about current events such as the latest news.",
              "The assistant can answer questions based on a specific selection of internal information sources.",
              "The sources for internal documentation will always be listed.",
              "You can upload documents and discuss them with the assistant, for example to summarize them or extract action points."
            ]
          },
          {
            "heading": "How to get the most out of the assistant?",
            "items": [
              "Ask a clear question in full sentences. Single keywords often produce mediocre answers; a full sentence gives the assistant the context it needs to help you well.",
              "Within one conversation the assistant remembers what you said earlier, so you can ask follow-up questions. It does not understand what you mean if you refer to information from other conversations.",
              "Start a new conversation (button at the top left) when switching to a different topic, so answers stay sharp."
            ]
          },
          {
            "heading": "Important: responsible use of AI",
            "items": [
              "Use only approved AI tools (Holly and Microsoft Copilot) for work.",
              "Holly is designed to ensure sensitive data stays within the company.",
              "Do not share confidential or sensitive data to other AI tools not available from the company.",
              "Always review and validate AI-generated output before using or sharing it.",
              "Follow company policies, data security standards, and applicable regulations (including the EU AI Act)."
            ]
          }
        ],
        "notes": [
          "Note: this is an AI assistant, not an AI agent. It helps you with individual tasks when you ask, for example summarizing an email, but does not autonomously take follow-up actions like sending emails.",
          "Use the thumbs under an answer to give feedback. That helps make the assistant smarter."
        ]
      },
      "nl": {
        "title": "Over de Holly assistent",
        "intro": "Welkom bij de Holly assistent. Hieronder lees je waar de assistent je mee kan helpen en hoe je er het beste uithaalt. Holly draait in een beveiligde Holland Colours-omgeving, zodat je gegevens binnen het bedrijf blijven.",
        "sections": [
          {
            "heading": "Waar kan de assistent je mee helpen?",
            "items": [
              "De assistent kan vragen beantwoorden zoals je die aan ChatGPT zou stellen.",
              "De assistent heeft veel algemene kennis, maar weet niets van actualiteiten zoals het laatste nieuws.",
              "De assistent kan vragen beantwoorden op basis van een specifieke selectie aan interne informatiebronnen.",
              "De bronnen voor interne documentatie worden altijd vermeld.",
              "Je kunt documenten uploaden en daar met de assistent over praten, bijvoorbeeld om ze samen te vatten of actiepunten op te halen."
            ]
          },
          {
            "heading": "Zo haal je het beste uit de assistent",
            "items": [
              "Stel een duidelijke vraag in volzinnen. Losse trefwoorden leveren vaak een matig antwoord op; een volledige zin geeft de assistent de context om je goed te helpen.",
              "Binnen één gesprek onthoudt de assistent wat je eerder hebt gezegd, zodat je vervolgvragen kunt stellen. Hij begrijpt echter niet wat je bedoelt als je verwijst naar informatie uit andere gesprekken.",
              "Begin een nieuw gesprek (knop linksboven) zodra je over een ander onderwerp wilt praten, dan blijven antwoorden scherp."
            ]
          },
          {
            "heading": "Belangrijk: verantwoord gebruik van AI",
            "items": [
              "Gebruik voor werk alleen goedgekeurde AI-tools (Holly en Microsoft Copilot).",
              "Holly is ontworpen om gevoelige gegevens binnen het bedrijf te houden.",
              "Deel geen vertrouwelijke of gevoelige gegevens met andere AI-tools die niet door het bedrijf beschikbaar worden gesteld.",
              "Controleer en valideer door AI gegenereerde uitvoer altijd voordat je deze gebruikt of deelt.",
              "Volg het bedrijfsbeleid, de normen voor gegevensbeveiliging en de geldende regelgeving (waaronder de EU AI-verordening)."
            ]
          }
        ],
        "notes": [
          "Let op: dit is een AI-assistent, geen AI-agent. Hij helpt je bij losse taken als je daarom vraagt, bijvoorbeeld een e-mail samenvatten, maar onderneemt niet zelfstandig vervolgacties zoals e-mails versturen.",
          "Gebruik de duimpjes onder een antwoord om feedback te geven. Daarmee help je de assistent slimmer te maken."
        ]
      },
      "hu": {
        "title": "A Holly asszisztensről",
        "intro": "Üdvözlünk a Holly asszisztensénél. Az alábbiakban megtudhatod, miben tud segíteni az asszisztens, és hogyan hozhatod ki belőle a legtöbbet. A Holly egy biztonságos Holland Colours-környezetben fut, így az adataid a vállalaton belül maradnak.",
        "sections": [
          {
            "heading": "Miben tud segíteni az asszisztens?",
            "items": [
              "Az asszisztens olyan kérdésekre tud válaszolni, mint amilyeneket a ChatGPT-nek tennél fel.",
              "Az asszisztens széles körű általános tudással rendelkezik, de nem ismeri az aktuális eseményeket, például a legfrissebb híreket.",
              "Az asszisztens belső információforrások egy meghatározott válogatása alapján tud válaszolni a kérdésekre.",
              "A belső dokumentáció forrásai mindig fel vannak tüntetve.",
              "Feltölthetsz dokumentumokat, és megbeszélheted azokat az asszisztenssel, például az összefoglalásukhoz vagy a teendők kiemeléséhez."
            ]
          },
          {
            "heading": "Hogyan hozd ki a legtöbbet az asszisztensből",
            "items": [
              "Tegyél fel egyértelmű kérdést teljes mondatokban. Az egyszavas kulcsszavak gyakran közepes válaszokat eredményeznek; egy teljes mondat megadja az asszisztensnek a szükséges kontextust, hogy jól segíthessen.",
              "Egy beszélgetésen belül az asszisztens emlékszik arra, amit korábban mondtál, így feltehetsz további kérdéseket. Nem érti, mire gondolsz, ha más beszélgetésekből származó információkra hivatkozol.",
              "Indíts új beszélgetést (a bal felső sarokban lévő gombbal), amikor másik témára váltasz, hogy a válaszok pontosak maradjanak."
            ]
          },
          {
            "heading": "Fontos: a mesterséges intelligencia felelős használata",
            "items": [
              "Munkához kizárólag jóváhagyott MI-eszközöket használj (Holly és Microsoft Copilot).",
              "A Holly úgy lett kialakítva, hogy az érzékeny adatok a vállalaton belül maradjanak.",
              "Ne ossz meg bizalmas vagy érzékeny adatokat olyan MI-eszközökkel, amelyeket a vállalat nem biztosít.",
              "Az MI által generált tartalmat mindig ellenőrizd és érvényesítsd, mielőtt felhasználod vagy megosztod.",
              "Tartsd be a vállalati irányelveket, az adatbiztonsági normákat és a vonatkozó jogszabályokat (beleértve az EU MI-rendeletét)."
            ]
          }
        ],
        "notes": [
          "Megjegyzés: ez egy MI-asszisztens, nem MI-ügynök. Egyedi feladatokban segít, amikor kéred, például egy e-mail összefoglalásában, de nem hajt végre önállóan további műveleteket, például e-mailek küldését.",
          "Használd a válasz alatti hüvelykujjakat, hogy visszajelzést adj. Ezzel segítesz okosabbá tenni az asszisztenst."
        ]
      },
      "id": {
        "title": "Tentang asisten Holly",
        "intro": "Selamat datang di asisten Holly. Di bawah ini Anda akan menemukan apa yang dapat dibantu oleh asisten dan cara memanfaatkannya secara maksimal. Holly berjalan di lingkungan Holland Colours yang aman, sehingga data Anda tetap berada di dalam perusahaan.",
        "sections": [
          {
            "heading": "Apa yang dapat dibantu oleh asisten?",
            "items": [
              "Asisten dapat menjawab pertanyaan seperti yang akan Anda ajukan ke ChatGPT.",
              "Asisten memiliki pengetahuan umum yang luas, tetapi tidak mengetahui peristiwa terkini seperti berita terbaru.",
              "Asisten dapat menjawab pertanyaan berdasarkan pilihan khusus dari sumber informasi internal.",
              "Sumber untuk dokumentasi internal akan selalu dicantumkan.",
              "Anda dapat mengunggah dokumen dan mendiskusikannya dengan asisten, misalnya untuk meringkasnya atau mengekstrak poin-poin tindakan."
            ]
          },
          {
            "heading": "Cara memanfaatkan asisten secara maksimal",
            "items": [
              "Ajukan pertanyaan yang jelas dalam kalimat lengkap. Kata kunci tunggal sering menghasilkan jawaban yang biasa-biasa saja; kalimat lengkap memberi asisten konteks yang dibutuhkan untuk membantu Anda dengan baik.",
              "Dalam satu percakapan, asisten mengingat apa yang Anda katakan sebelumnya, sehingga Anda dapat mengajukan pertanyaan lanjutan. Asisten tidak memahami maksud Anda jika Anda merujuk pada informasi dari percakapan lain.",
              "Mulai percakapan baru (tombol di kiri atas) saat beralih ke topik yang berbeda, agar jawaban tetap tajam."
            ]
          },
          {
            "heading": "Penting: penggunaan AI yang bertanggung jawab",
            "items": [
              "Gunakan hanya alat AI yang disetujui (Holly dan Microsoft Copilot) untuk bekerja.",
              "Holly dirancang untuk memastikan data sensitif tetap berada di dalam perusahaan.",
              "Jangan bagikan data rahasia atau sensitif ke alat AI lain yang tidak disediakan oleh perusahaan.",
              "Selalu tinjau dan validasi keluaran yang dihasilkan AI sebelum menggunakan atau membagikannya.",
              "Patuhi kebijakan perusahaan, standar keamanan data, dan peraturan yang berlaku (termasuk EU AI Act)."
            ]
          }
        ],
        "notes": [
          "Catatan: ini adalah asisten AI, bukan agen AI. Asisten membantu Anda dengan tugas individual saat Anda meminta, misalnya meringkas email, tetapi tidak secara mandiri mengambil tindakan lanjutan seperti mengirim email.",
          "Gunakan ikon jempol di bawah jawaban untuk memberikan masukan. Itu membantu membuat asisten lebih cerdas."
        ]
      }
    }
  }
};

export const CLIENT_ID = CLIENT_CONFIG.client_id;

export const IS_DEVELOPMENT = false;
